import { CommonModule, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component } from '@angular/core';
import { KENDO_BUTTON, KENDO_BUTTONGROUP, KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import { EventsComponent } from './events/events.component';
import { ImoComponent } from './imo/imo.component';
import { LogoManagerComponent } from './logo-manager/logo-manager.component';
import { ProductsComponent } from './products/products.component';
import { SponsorComponent } from './sponsor/sponsor.component';

@Component({
  selector: 'gd-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  imports: [
    CommonModule,
    KENDO_BUTTON,
    KENDO_BUTTONS,
    KENDO_BUTTONGROUP,
    NgSwitch,
    NgSwitchCase,
    LogoManagerComponent,
    EventsComponent,
    ProductsComponent,
    SponsorComponent,
    ImoComponent,
  ]
})
export class AdminComponent {
  public adminSectionEnum = AdminSectionEnum
  public currentSection: AdminSectionEnum = AdminSectionEnum.LogoManager

  public switchSection(section: AdminSectionEnum) {
    this.currentSection = section
  }
}

export enum AdminSectionEnum {
  LogoManager,
  Events,
  Products,
  Sponsor,
  Imo,
}
